<template>
  <div class="result-layout">
    <div class="result">
      <div class="flex">
        <div class="wrap">
          <header :style='headerStyle' class="result-intro result-header">
            <h1>{{$t(config.options.title, 'options.title')}}</h1>
          </header>
          <div class="wrap result-components">
          <component v-bind:result='result' @scroll='onScrollToTarget' :class='"result-" + resultComponent.type.toLowerCase()' :key='"result-component-"+i' v-for='(resultComponent, i) in config.options.components' :data-index='i' :id='"result-component-" + (i+1)' :is='resultComponent.type' :config='resultComponent.options'>
              <template slot='comptype'>
                {{ resultComponent.type }}
              </template>
          </component>
          <CCFooter ref='footer'></CCFooter>
        </div>
        </div>
      </div>
    </div>
    <PoweredBy></PoweredBy>
  </div>
</template>

<script>
import mezr from 'mezr'
import Scoring from '../lib/Scoring'
import ResultSignup from './Signup'
import Velocity from 'velocity-animate'
import ResultScore from './ResultScore'
import ResultScoreIndicator from './ResultScoreIndicator'
import ResultCompare from './ResultCompare'
import ResultDebug from './ResultDebug'
import ResultText from './ResultText'
import ResultTip from './ResultTip'
import ResultBreakdown from './ResultBreakdown'
import ResultAgreement from './ResultAgreement'
import ResultPollAverage from './ResultPollAverage'
import Button from './Button'
import CCFooter from './CCFooter'
import ResultCustom from './ResultCustom'
import TranslationMixin from '../lib/TranslationMixin'
import PoweredBy from './PoweredBy'

export default {
  name: 'ResultPage',
  components: {
    Signup: ResultSignup, // because we renamed it...
    ResultScore,
    ResultScoreIndicator,
    ResultCompare,
    ResultText,
    ResultTip,
    ResultBreakdown,
    ResultAgreement,
    ResultPollAverage,
    ResultDebug,
    Button,
    CCFooter,
    ResultCustom,
    PoweredBy
  },
  props: ['config'],
  mixins: [Scoring, TranslationMixin],
  data () {
    return {
      result: {}
    }
  },
  computed: {
    headerStyle () {
      return {
        backgroundColor: this.config.options.backgroundColor || this.theme.secondary.backgroundColor,
        color: this.config.options.textColor || this.theme.secondary.color
      }
    }
  },
  methods: {
    onScrollToTarget (ev) {
      this.scrollTo(ev)
    },
    scrollTo (ref) {
      let tgt = document.getElementById(ref)
      if (ref) {
        Velocity.animate(
          tgt, 'scroll', 750
        )
      }
    },
    update (resp) {
      this.result = resp.data
      this.$store.commit('setResultURL', this.result.url)
      this.$store.commit('setStatus', this.result.status)
    },
    onWindowScroll (event) {
      let totalHeight = mezr.height(document) - mezr.height(window)
      let scrollY = mezr.offset(window, 'scroll').top
      let threshold = mezr.height(this.$refs.footer.$el)
      if (scrollY > (totalHeight - threshold)) {
        document.body.classList.add('scroll-end')
      } else {
        document.body.classList.remove('scroll-end')
      }
    }
  },
  created () {
    this.$gtag.event('complete', {event_category: 'result', event_label: 'finalised', value: 1})
    this.$store.dispatch('finalise').then(() => {
      this.convince.result().then(this.update)
    })
    window.addEventListener('scroll', this.onWindowScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onWindowScroll)
  },
  inject: ['convince', 'theme'],
  mounted () {
    let links = document.querySelectorAll('a')
    for (let link of links) {
      if (!link.href) {
        break
      }
      if (link.host !== location.host) {
        link.setAttribute('target', '_blank')
      }
    }
    window.scroll(0, 0)
  }
}
</script>

<style lang='scss'>

</style>
